"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var api_request_1 = require("../api_request");
var url_helpers_1 = require("../shared/url_helpers");
var rql_1 = require("../../schemas/rql");
function domIDToReplace(negotiationId) {
    return "#negotiation_" + negotiationId;
}
function decrementDashboardOfferBadges(party) {
    Reverb.Badges.decrementBadge('total_active_offers_badge');
    if (party === rql_1.core_apimessages_NegotiationParty.BUYER) {
        Reverb.Badges.decrementBadge('buyer_active_offers_badge');
    }
    else {
        Reverb.Badges.decrementBadge('seller_active_offers_badge');
    }
}
/** Legacy compatibility for existing Rails offer dashboard partial reload */
function refreshDashboard(negotiationID, refreshMessage, party) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    decrementDashboardOfferBadges(party);
                    Reverb.UI.spinWithMessage(domIDToReplace(negotiationID), refreshMessage);
                    return [4 /*yield*/, api_request_1.get(url_helpers_1.default.myOffersOfferCard(negotiationID), {}, {}, '')];
                case 1:
                    response = _a.sent();
                    Reverb.UI.updateAndHighlight(response.dom_id, response.template);
                    return [2 /*return*/];
            }
        });
    });
}
exports.refreshDashboard = refreshDashboard;
//# sourceMappingURL=refresh_dashboard.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/offers/refresh_dashboard.js
// module id = E7+W
// module chunks = 20 21